<div class="grid-x">
  <input class="show-for-sr" type="text" [id]="controlId" [name]="controlName">
  <label [for]="controlId">
    <i aria-hidden="true"></i>
    <span class="control-label-text" [innerHTML]="componentData.label | safeHtml"></span>
  </label>
  <div class="address-group-container">
    <div class="address-row">
      <span class="address-labels">Address:</span>
      <input class="show-this" type="text" placeholder="Address" >
    </div>
    <!-- <div>
    <input class="show-for-sr" type="text" placeholder="Address">
    <input class="show-for-sr" type="text" placeholder="Address">
  </div> -->
  <div class="address-row">
    <span class="address-labels">City:</span>
    <input class="show-this" type="text" placeholder="City" >
  </div>
  <!-- <div>
  <input class="show-for-sr" type="text" placeholder="City">
</div> -->
<div class="label-text">State:</div>
<select [(ngModel)]="selectedItem" >
  @for (state of states; track state) {
    <option
      value="item">
      {{state}}
    </option>
  }
</select>
<div class="label-text">
  <span class="address-labels">Zip Code:</span>
  <input type="text" >
</div>
</div>
</div>
